import { render, staticRenderFns } from "./KdsRoutingFlowForm.vue?vue&type=template&id=99359564&scoped=true&"
import script from "./KdsRoutingFlowForm.vue?vue&type=script&lang=js&"
export * from "./KdsRoutingFlowForm.vue?vue&type=script&lang=js&"
import style0 from "./KdsRoutingFlowForm.vue?vue&type=style&index=0&id=99359564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99359564",
  null
  
)

export default component.exports